import ShareIcon from '@mui/icons-material/Share';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { defaultImage } from '../../constants';
import CounterApp from '../counter/Counter';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Table } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
const ProjectsCard = ({
  i,
  data,
  handleOnChange,
  handleShareLink,
  addCartItem,
  DonateHandle,
  previousIndex,
  setPreviousIndex,
  setCurrentIndex,
  setCount,
  setAmount,
  amount,
  count,
  currentIndex,
  errorStates,
  isLoading,
  selectedValues,
  setSmsModal,
  setProjectId,
}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const location = useLocation();
  const { projectTypeIdInt } = useParams();
  const pid = location.pathname.split('/')[4];
  const shouldHideIcon = location.pathname.includes('PaymentProcess');
  const { t } = useTranslation();
  const routeMatch = location.pathname === '/GeneralDonation' || location.pathname === '/user/GeneralDonation';

  const amountButton = [
    { id: 1, network: 'Ufone', amount: 10 },
    { id: 2, network: 'Ufone', amount: 50 },
    { id: 3, network: 'Ufone', amount: 100 },
    { id: 4, network: 'Ufone', amount: 200 },
    { id: 5, network: 'Ufone', amount: 500 },
    { id: 6, network: 'Ufone', amount: 1000 },
  ];
  const isHomePage = location.pathname === '/';
  return (
    <div className="bg-white border m-1 w-96 my-3 border-gray-200 rounded-3xl shadow  px-3 hover:scale-105 transition-transform duration-300">
      <div className="py-1 justify-center  ">
        <div className={` flex justify-between text-center  ${isActive ? 'pl-12' : 'pr-12'}`}>
          {!shouldHideIcon && (
            <ShareIcon
              onClick={() => handleShareLink(data?.id, data?.projectTypeIdInt)}
              className={`w-7 h-7 items-center cursor-pointer text-customgreen hover:text-hovergreen m-3 transition-colors duration-700 ${
                isActive ? 'rotate-180' : ''
              }`}
            />
          )}

          <div className={`flex justify-center items-center w-full ${shouldHideIcon && 'my-3'}`}>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${currentIndex}`} className="custom-tooltip">
                  {data?.title_AR
                    ? isActive
                      ? data?.title_AR
                      : data?.title_EN
                    : data?.titleAr
                      ? isActive
                        ? data?.titleAr
                        : data?.titleEn
                      : data?.projectNameAr
                        ? isActive
                          ? data?.projectNameAr
                          : data?.projectNameEn
                        : isActive
                          ? data?.templateName
                          : data?.templateName}
                </Tooltip>
              }
            >
              <h3 className="capitalize truncate text-wrap font-semibold text-customgreen">
                {data?.title_AR
                  ? t(
                      isActive
                        ? data?.title_AR?.length > 15
                          ? `${data?.title_AR.slice(0, 15)}...`
                          : data?.title_AR
                        : data?.title_EN?.length > 15
                          ? `${data?.title_EN.slice(0, 15)}...`
                          : data?.title_EN,
                    )
                  : data?.titleAr
                    ? t(
                        isActive
                          ? data?.titleAr?.length > 15
                            ? `${data?.titleAr.slice(0, 15)}...`
                            : data?.titleAr
                          : data?.titleEn?.length > 15
                            ? `${data?.titleEn.slice(0, 15)}...`
                            : data?.titleEn,
                      )
                    : data?.projectNameAr
                      ? t(
                          isActive
                            ? data?.projectNameAr?.length > 15
                              ? `${data?.projectNameAr.slice(0, 15)}...`
                              : data?.projectNameAr
                            : data?.projectNameEn?.length > 15
                              ? `${data?.projectNameEn.slice(0, 15)}...`
                              : data?.projectNameEn,
                        )
                      : t(
                          isActive
                            ? data?.templateName?.length > 15
                              ? `${data?.templateName.slice(0, 15)}...`
                              : data?.templateName
                            : data?.templateName?.length > 15
                              ? `${data?.templateName.slice(0, 15)}...`
                              : data?.templateName,
                        )}
              </h3>
            </OverlayTrigger>
          </div>
        </div>

        {data?.sourceType !== 3 &&
          (data?.picture || data?.imageURL || data?.imagePath ? (
            <img
              className="w-full h-32 mx-auto rounded-t-2xl"
              src={`data:image/jpeg;base64,
                              ${data?.picture != null || data?.imageURL != null || (data?.imagePath && data?.picture !== '') || data?.imageURL !== '' || data?.imagePath !== '' ? data?.picture || data?.imageURL || data?.imagePath : defaultImage}`}
              alt="project Name"
            />
          ) : (
            <img
              className="w-full h-32 mx-auto rounded-t-2xl"
              src={`data:image/jpeg;base64,
                              ${data?.imageByte1 != null && data?.imageByte1 !== '' ? data?.imageByte1 : defaultImage}`}
              alt="project Name"
            />
          ))}
        {data?.sourceType == 3 &&
          (data?.familyMembersCount > 0 ? (
            <img
              className="w-full h-32 mx-auto rounded-t-2xl"
              src={'/assets/sponsor_images/Family.png'}
              alt="project Name"
            />
          ) : (
            <img
              className="w-full h-32 mx-auto rounded-t-2xl"
              src={`${data?.genderNameEn == 'Male' ? '/assets/sponsor_images/Male.png' : '/assets/sponsor_images/Female.png'}`}
              alt="project Name"
            />
          ))}

        {data?.isContribution === true ? (
          <div className="relative w-full mx-auto h-6 bg-gray-200 ">
            <div
              className={`absolute top-0 ${isActive ? 'right-0' : 'left-0'} h-full text-center ${data?.receivedPercentage === 0 ? 'text-black' : 'text-white'} bg-customgreen`}
              style={{ width: `${data?.receivedPercentage}%` }}
            >
              {data?.receivedPercentage}%
            </div>
          </div>
        ) : (
          <div className="relative w-full mx-auto h-6">
            <div></div>
          </div>
        )}
        <div className="">
          {
            // data?.sourceType !== 5 &&
            pid != 14 &&
              ((data?.price !== null && data?.price !== undefined) ||
              (data?.totalCost !== null && data?.totalCost !== undefined) ||
              (data?.amount !== null && data?.amount !== undefined) ? (
                <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900">
                  {t('Total Cost')} <span className="mx-2">:</span>
                  <span className={`${isActive ? 'ml-2' : 'mr-2'} text-customorange font-bold`}>
                    {/* {data?.price || data?.totalCost || data?.amount} */}
                    {/* {data?.price ?? data?.totalCost ?? data?.amount} */}
                    {data?.sourceType !== 3
                      ? data?.price ?? data?.totalCost ?? data?.amount
                      : selectedValues[0] === 2
                        ? data?.amount
                        : data?.amount * 12}
                  </span>
                  <span className={`${isActive ? 'ml-2' : 'mr-2'} font-bold`}>{t('AED')}</span>
                </h5>
              ) : null)
          }
          <p className=" px-2 lg:px-3 text-sm text-center truncate  tracking-tight text-gray-900 ">
            {isActive ? data?.details_AR || data?.descriptionAr : data?.details_EN || data?.descriptionEnglish}
          </p>
          <div
            className={`flex items-center pb-3 justify-around flex-col-reverse md:flex-row-reverse space-x-1 ${data?.isContribution != null && data?.isContribution === true ? 'mt-0' : 'mt-0'}`}
          ></div>

          {(routeMatch || pid == '14') && (
            <div className="flex gap-3 justify-center sxx:justify-start flex-wrap">
              {amountButton?.map((item, index) => (
                <div key={index} className="mb-2 cursor-pointer sm:w-full w-auto">
                  <button
                    onClick={() => {
                      setAmount(item.amount), setPreviousIndex(i), setCurrentIndex(i);
                    }}
                    className="text-white px-4 w-full from-customgreen via-customgreen to-customgreen bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-customgreen dark:focus:ring-customgreen font-medium rounded-md text-sm py-2 text-center"
                  >
                    {item.amount}
                  </button>
                </div>
              ))}
            </div>
          )}
          <div className={`space-y-4 ${data?.isAltakamul ? '' : 'pb-3'}`}>
            {data?.isRecurring && (
              <div className="flex gap-3 justify-between">
                {/* One Time Payment Radio Button */}
                <div
                  onClick={() => handleOnChange(i, 1)}
                  className={`w-full cursor-pointer flex items-center border-2 ${
                    selectedValues[i] === 1
                      ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                      : 'border-gray-200'
                  } rounded-full dark:border-gray-700 p-2`}
                >
                  <input
                    onChange={(e) => {
                      handleOnChange(i, 1);
                    }}
                    id={`bordered-radio-1-${i}`}
                    type="radio"
                    value={1}
                    name={`payment-${i}`}
                    defaultChecked
                    className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                    checked={selectedValues[i] === 1}
                  />
                  <label htmlFor={`bordered-radio-1-${i}`} className="w-full ms-2 text-sm cursor-pointer font-medium">
                    {t('One Time')}
                  </label>
                </div>

                {/* Monthly Payment Radio Button */}
                <div
                  onClick={() => handleOnChange(i, 2)}
                  className={`w-full cursor-pointer flex items-center border-2 ${
                    selectedValues[i] === 2
                      ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                      : 'border-gray-200'
                  } rounded-full dark:border-gray-700 p-2`}
                >
                  <input
                    onChange={(e) => {
                      handleOnChange(i, 2);
                    }}
                    id={`bordered-radio-2-${i}`}
                    type="radio"
                    value={2}
                    name={`payment-${i}`}
                    className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                    checked={selectedValues[i] === 2}
                  />
                  <label htmlFor={`bordered-radio-2-${i}`} className="w-full ms-2 text-sm cursor-pointer font-medium">
                    {t('Monthly')}
                  </label>
                </div>
              </div>
            )}
            <div className="flex flex-col sxx:flex-row-reverse sm:flex-row-reverse md:flex-row-reverse lg:flex-row-reverse xl:flex-row-reverse items-center justify-around gap-4 ">
              {projectTypeIdInt != 16 &&
                projectTypeIdInt != 9 &&
                projectTypeIdInt != 10 &&
                projectTypeIdInt != 3 &&
                projectTypeIdInt != 1 &&
                projectTypeIdInt != 2 &&
                projectTypeIdInt != 4 &&
                projectTypeIdInt != 8 &&
                projectTypeIdInt != 1052 &&
                projectTypeIdInt != 12 &&
                projectTypeIdInt != 1052 &&
                projectTypeIdInt != 1053 &&
                projectTypeIdInt != 22 &&
                projectTypeIdInt != 1054 &&
                projectTypeIdInt != 1051 && (
                  <div className=" w-full">
                    {!isHomePage && (
                      <input
                        id={`amount-${i + 1}`}
                        name={`amount-${i}`}
                        type="text"
                        value={
                          previousIndex === i ? amount : 0
                          // routeMatch
                          //   ? previousIndex === i
                          //     ? amount || ''
                          //     : ''
                          //   : previousIndex === i
                          //     ? amount || data.amount
                          //     : data.totalCost || data.price || data.amount
                        }
                        onInput={(event) => {
                          const { name, value } = event.target;
                          const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

                          if (regex.test(value) || value === '') {
                            setPreviousIndex(i);
                            setCurrentIndex(i);
                            setAmount(value);
                          } else {
                            event.target.value = value.replace(/\D/g, '');
                          }
                        }}
                        className={`${data?.isContribution == false && 'bg-gray-200 cursor-not-allowed'}  w-full 'focus:border-customgreen border border-customgreen focus:ring-2 focus:ring-customgreen rounded-full`}
                        placeholder={t('Enter Amount')}
                        maxLength={7}
                        min="0"
                        disabled={data?.isContribution == false || data?.isContribution == false}
                      />
                    )}
                  </div>
                )}

              {data?.sourceType == 1 && (
                <>
                  {projectTypeIdInt == 3 && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Depth')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Duration')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>

                          <Table.Cell className="p-1  flex-1 truncate">{data?.depth || '-'}</Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.duration || '-'}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}

                  {projectTypeIdInt == 1 && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Roof Type')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Prayers')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Area')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Duration')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">
                            {isActive ? data?.roofType_AR : data?.roofType || '-'}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.capacity || '-'}</Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">
                            {data?.length && data?.width ? `${data.length * data.width} m` : '-'}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.duration || '-'}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                  {projectTypeIdInt == 2 && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Student')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Area')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Duration')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.capacity || '-'}</Table.Cell>

                          <Table.Cell className="p-1  flex-1 truncate">
                            {data?.length && data?.width ? `${data.length * data.width} m` : '-'}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.duration || '-'}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                  {(projectTypeIdInt == 16 || projectTypeIdInt == 9 || projectTypeIdInt == 10) && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>
                          {/* <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                                      {t('Detail')}
                                    </Table.HeaderCell> */}
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Duration')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>
                          {/* <Table.Cell className="p-1  flex-1 truncate">
                                      {isActive ? data?.detailAr : data?.detailEn || '-'}
                                    </Table.Cell> */}
                          <Table.Cell className="p-1  flex-1 truncate">{data?.duration || '-'}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                  {projectTypeIdInt == 4 && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>

                          {/* <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                                      {t('Detail')}
                                    </Table.HeaderCell> */}
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>
                          {/* <Table.Cell className="p-1  flex-1 truncate">
                                      {isActive ? data?.detailAr: data?.detailEn || '-'}
                                    </Table.Cell> */}
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                  {projectTypeIdInt == 8 && (
                    <Table className="text-xs text-center w-full table-fixed">
                      <Table.Header className="text-xs font-bold text-white bg-customgreen ">
                        <Table.Row className="flex justify-between">
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Country')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Roof Type')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Bath Rooms')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Rooms')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3 flex-1 truncate">
                            {t('Area')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white p-1 py-3  flex-1 truncate">
                            {t('Duration')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="flex justify-between">
                          <Table.Cell className="p-1 flex-1 truncate">
                            {isActive ? data?.countryName_AR : data?.countryName}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">
                            {isActive ? data?.roofType_AR : data?.roofType || '-'}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.bathRoom || '-'}</Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.totalRooms || '-'}</Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">
                            {data?.length && data?.width ? `${data.length * data.width} m` : '-'}
                          </Table.Cell>
                          <Table.Cell className="p-1  flex-1 truncate">{data?.duration || '-'}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                </>
              )}

              {data?.sourceType == 3 && (
                <>
                  {data?.sponsershipTypeId === 1052 && (
                    <div className="w-full">
                      <Table className="text-sm text-center">
                        <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase">
                          <Table.Row>
                            <>
                              <Table.HeaderCell className="text-white whitespace-nowrap">
                                {t('Family Members')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">
                                {t('Health Condition')}
                              </Table.HeaderCell>
                            </>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell className="whitespace-nowrap">{data?.familyMembersCount}</Table.Cell>
                            <Table.Cell className="whitespace-nowrap">
                              {isActive ? data?.healthConditionAr : data?.healthConditionEn || '-'}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </div>
                  )}

                  {(data?.sponsershipTypeId === 12 ||
                    data?.sponsershipTypeId === 1051 ||
                    data?.sponsershipTypeId === 1054 ||
                    data?.sponsershipTypeId === 22 ||
                    data?.sponsershipTypeId === 1053) && (
                    <div className="w-full">
                      <Table className="text-sm text-center">
                        <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase">
                          <Table.Row>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Age')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Sex')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell className="whitespace-nowrap">{data?.age}</Table.Cell>
                            <Table.Cell className="whitespace-nowrap">
                              {`${t(isActive ? data?.genderNameAr : data?.genderNameEn)}`}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </div>
                  )}
                </>
              )}

              {data?.isCounter && (
                <div className="w-full">
                  <CounterApp
                    index={i}
                    previousIndex={previousIndex}
                    setPreviousIndex={setPreviousIndex}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    count={count}
                    setCount={setCount}
                    amount={amount}
                    setAmount={setAmount}
                    price={data.price || data.totalCost || data.amount}
                  />
                </div>
              )}
            </div>

            <p className="text-red-900 text-center">{errorStates[i] && 'Amount Must be Greater Than 0'}</p>

            <div className="flex flex-col sxx:flex-row sm:flex-row md:flex-row lg:flex-row xl:flex-row items-center justify-around gap-3 ">
              <button
                className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center transition duration-700 ease-in-out "
                onClick={() => {
                  DonateHandle(
                    currentIndex,
                    i,
                    data?.id,
                    data.price || data.totalCost || data.amount,
                    data?.id,
                    data?.isContribution,
                    data?.projectTypeIdInt,
                  );
                  data?.isContribution && setAmount(data?.isContribution ? data?.price || data?.totalCost : null);
                }}
              >
                {t('Donate Now')}{' '}
              </button>
              <button
                disabled={isLoading ? true : false}
                onClick={() => {
                  addCartItem(
                    currentIndex,
                    i,
                    data.price || data.totalCost || data.amount,
                    data?.id,
                    data?.projectTypeIdInt,
                    pid,
                  );
                  data?.isContribution && setAmount(data?.isContribution ? data?.price || data.totalCost : null);
                }}
                type="button"
                className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-2 flex justify-center items-center transition duration-700 ease-in-out"
              >
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M10 20.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.304-17l-3.431 14h-2.102l2.541-11h-16.812l4.615 13h13.239l3.474-14h2.178l.494-2h-4.196z" />
                </svg>

                <span className="sr-only">Icon description</span>
              </button>
            </div>

            {data?.isAltakamul && (
              <div className="w-full pb-3">
                <button
                  className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center uppercase transition duration-700 ease-in-out"
                  onClick={() => {
                    setProjectId(data?.id);
                    setSmsModal(true);
                  }}
                >
                  {t('sms')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;
